import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navItems } from "@/mocks/nav";

function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            嘿咻嘿咻漫画
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm transition-colors whitespace-nowrap ${
                  isActive
                    ? "bg-primary-100 text-primary-800 font-medium"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/plot"
            className="rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            开始追更
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="切换菜单"
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-sm ${
                    isActive
                      ? "bg-primary-100 text-primary-800 font-medium"
                      : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/plot"
              className="mt-2 rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              开始追更
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}

export default Navbar;